import { RatesTable } from '@/features/rates/components/RatesTable';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/rates')({
  component: RatesPage,
});

function RatesPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Rates</h1>
      <RatesTable />
    </div>
  );
}
